import Cookies from "js-cookie";

export const getTokens = () => {
  return {
    // access_token: Cookies.get("access_token"),
    // refresh_token: Cookies.get("refresh_token"),
    access_token: Cookies.get("access_token") || localStorage.getItem("access_token") || localStorage.getItem("token"),
    refresh_token: Cookies.get("refresh_token") || localStorage.getItem("refresh_token"),
    // Firebase токени більше не використовуються
    firebase_token: Cookies.get("firebase_token"), // Залишаємо для сумісності зі старими користувачами
    firebase_refresh_token: Cookies.get("firebase_refresh_token"), // Залишаємо для сумісності
  };
};

export const setTokens = (tokens, expirationDays = 30) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + expirationDays);

  const accessToken = tokens?.access || tokens?.access_token;
  if (accessToken) {
    Cookies.set("access_token", accessToken, { expires: expirationDate });
    try {
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("token", accessToken);
    } catch (e) {
      console.warn("Could not save access_token to localStorage", e);
    }
  }
  const refreshTokenVal = tokens?.refresh || tokens?.refresh_token;
  if (refreshTokenVal) {
    Cookies.set("refresh_token", refreshTokenVal, { expires: expirationDate });
    try {
      localStorage.setItem("refresh_token", refreshTokenVal);
    } catch (e) {
      console.warn("Could not save refresh_token to localStorage", e);
    }
  }
  
  // Firebase токени більше не зберігаємо для нових користувачів
  // Але залишаємо можливість для сумісності зі старими користувачами
  if (tokens?.firebase) {
    Cookies.set("firebase_token", tokens.firebase, { expires: expirationDate });
  }
  if (tokens?.firebase_refresh) {
    Cookies.set("firebase_refresh_token", tokens.firebase_refresh, { expires: expirationDate });
  }
};

export const setAccessToken = (token) => {
  Cookies.set("access_token", token);
};

export const setRefreshToken = (token) => {
  Cookies.set("refresh_token", token);
};

export const setFirebaseToken = (token) => {
  Cookies.set("firebase_token", token);
};

export const setFirebaseRefreshToken = (token) => {
  Cookies.set("firebase_refresh_token", token);
};

export const clearTokens = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("firebase_token");
  Cookies.remove("firebase_refresh_token");
  try {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
  } catch (e) {
    console.warn("Could not remove tokens from localStorage", e);
  }
};


// export const setTokens = (tokens, expirationDays = 30) => {
//   const expirationDate = new Date();
//   expirationDate.setDate(expirationDate.getDate() + expirationDays);

//   Cookies.set("access_token", tokens?.access, { expires: expirationDate });
//   Cookies.set("refresh_token", tokens?.refresh, { expires: expirationDate });
  
//   // Firebase токени більше не зберігаємо для нових користувачів
//   // Але залишаємо можливість для сумісності зі старими користувачами
//   if (tokens?.firebase) {
//     Cookies.set("firebase_token", tokens.firebase, { expires: expirationDate });
//   }
//   if (tokens?.firebase_refresh) {
//     Cookies.set("firebase_refresh_token", tokens.firebase_refresh, { expires: expirationDate });
//   }
// };